import { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import { FormError } from './FormError';
import { FormItemLabel, FormItemValue, FormItemWrapper } from './FormItem.styled';
import { useFormUIContext } from './FormUIProvider';

export interface FormItemProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  label?: ReactNode;
  /**
   * @default "100px"
   */
  labelWidth?: string;
  labelStyle?: CSSProperties;
  bodyStyle?: CSSProperties;
  /**
   * 필수항목 여부
   *
   * @default false
   */
  required?: boolean;
  /**
   * 에러 메시지를 표시합니다.
   *
   * - label이 없을 경우 에러 메시지가 다른 요소를
   *   밀어낼 수 있습니다.
   */
  error?: ReactNode;
  /**
   * 라벨과 입력 영역의 방향
   *
   * @default "vertical"
   */
  direction?: 'vertical' | 'horizontal';
  /**
   * 에러 메시지가 다른 요소를 밀어낼 수 있도록 합니다.
   */
  errorAbsoluteDisable?: boolean;
  errorStyle?: CSSProperties;
}

export const FormItem = (props: FormItemProps) => {
  const context = useFormUIContext();

  const {
    children,
    label,
    labelWidth = context.labelWidth,
    labelStyle = context.labelStyle,
    bodyStyle,
    required,
    error,
    direction = context.direction ?? 'vertical',
    errorAbsoluteDisable,
    errorStyle,
    ...args
  } = props;

  return (
    <FormItemWrapper direction={direction} {...args}>
      {!!label && (
        <FormItemLabel
          style={{
            width: labelWidth,
            ...labelStyle,
          }}
        >
          {label}
          {required && <em>*</em>}
        </FormItemLabel>
      )}
      <FormItemValue direction={direction} style={bodyStyle}>
        <div>
          <FormError
            error={error}
            isAbsolute={errorAbsoluteDisable ? false : !!label}
            style={errorStyle}
          >
            {children}
          </FormError>
        </div>
      </FormItemValue>
    </FormItemWrapper>
  );
};
